
import _ from 'lodash';
import {setDefaults} from "@/router/helper";

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

//这个也是工厂生产，是后续开发版本
const orderProcessStepSetAndScheduling= () => import('@/views/BST/orderProcessStepSetAndScheduling.vue');
// const orderProcessStepSet= () => import('@/views/BST/orderProcessStepSet.vue');
// const teamStepScheduling= () => import('@/views/BST/teamStepScheduling.vue');
const processTeamPlanDetail= () => import('@/views/BST/processTeamPlanDetail.vue');
const orderBstAbout= () => import('@/views/BST/orderBstAbout.vue');


const routes = [
  {
    path:'orderProcessStepSetAndScheduling/:orderId',
    meta:{
      title:'工艺设定',
    },
    component:orderProcessStepSetAndScheduling
  },
  // {
  //   path:'orderProcessStepSet/:orderId',
  //   meta:{
  //     title:'订单工艺设定',
  //   },
  //   component:orderProcessStepSet
  // },
  // {
  //   path:'teamStepScheduling/:orderId',
  //   meta:{
  //     title:'订单工艺排产',
  //   },
  //   component:teamStepScheduling
  // },
  {
    path:'processTeamPlanDetail/:id',
    meta:{
      title:'排产详情',
    },
    component:processTeamPlanDetail
  },
  {
    path:'orderBstAbout/:orderId',
    meta:{
      title:'BST分析',
    },
    component:orderBstAbout
  },

];



export default setDefaults(routes);
